import { getApolloClient } from 'shared/graphql/client';
import {
    SAVED_LISTINGS_QUERY,
    ADD_SAVED_LISTING_MUTATION,
    REMOVE_SAVED_LISTING_MUTATION
} from './savedListings.queries';
import { UserSavedListingsQuery } from './savedListings.types';

const getSavedListings = () =>
    getApolloClient()
        .query<UserSavedListingsQuery>({
            query: SAVED_LISTINGS_QUERY,
            fetchPolicy: 'no-cache'
        })
        .then(({ data }) => data);

const addSavedListing = (listingId: number) =>
    getApolloClient()
        .mutate({
            mutation: ADD_SAVED_LISTING_MUTATION,
            variables: {
                id: listingId
            }
        })
        .then(({ data }) => {
            if (!data.saveFavouriteListing) {
                throw new Error('Error adding saved listing');
            }

            return data;
        });

const removeSavedListing = (listingId: number) =>
    getApolloClient()
        .mutate({
            mutation: REMOVE_SAVED_LISTING_MUTATION,
            variables: {
                id: listingId
            }
        })
        .then(({ data }) => {
            if (!data.deleteFavouriteListing) {
                throw new Error('Error removing saved listing');
            }

            return data;
        });

export { getSavedListings, addSavedListing, removeSavedListing };
